import { useEffect, useState } from "react"
import { Autocomplete, TextField } from "@mui/material"
import { useController, useWatch } from "react-hook-form"
import { useSearchFormContext } from "./SearchForm"
import { getUsersList } from "../../service/user"

function SearchSapUserDropdown({ label, dataLabel, soldToDataLabel, multiple }) {
    if (!soldToDataLabel) throw new Error("missing soldToDataLabel Prop on SearchSapUserDropdown Component")

    const [options, setOptions] = useState([])
    const { register, control, errors } = useSearchFormContext()
    const { field } = useController({ name: dataLabel, control, defaultValue: null })
    const soldToAccountNumber = useWatch({ name: soldToDataLabel, control })

    useEffect(() => {
        if (soldToAccountNumber) {
            getUsersList(soldToAccountNumber.key)
                .then(users => {
                    const options = users.map(user => ({
                        key: user.sap_contact_id,
                        value: `${user.first_name} ${user.last_name} - (${user.sap_function_descr})`
                    }))
                    setOptions(options)
                })
        } else setOptions([])
    }, [soldToAccountNumber])

    return (
        <div className={`searchForm ${multiple && "multi-select-dropdown"}`}>
            <label htmlFor={dataLabel}>{label}</label>
            <Autocomplete
                disablePortal
                id={dataLabel}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                options={options}
                multiple={multiple}
                filterSelectedOptions={multiple}
                freeSolo={multiple}
                sx={{ width: 300 }}
                onChange={(e, v) => {
                    if (multiple) {
                        const newElem = v[v.length - 1]
                        if (typeof newElem === "string")
                            v[v.length - 1] = { key: newElem, value: newElem }
                    }
                    field.onChange(v);
                }}
                value={field.value}
                getOptionLabel={(option) => option?.value}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={label}
                        error={Boolean(errors[dataLabel])}
                        onBlur={field.onBlur}
                        name={field.name}
                        sx={{ backgroundColor: "white" }}
                        size='small'
                    />
                )}
            />
        </div>
    )
}

export default SearchSapUserDropdown